import index from "./fileUploader.vue";
export default index;
